// extracted by extract-css-chunks-webpack-plugin
module.exports = {"hot":"hot-3Z_bhgZL clearfix","title":"title-2LUfZzws","text":"text-3GWeE0jB"};